import React from 'react'
import { Link } from 'gatsby'
import { useStaticQuery, graphql } from 'gatsby'
import * as classes from './index.module.css'
import Logo from '@Src/svgs/Logo'
import SubscribeForm from './Subscribe'
import RichText from '@components/RichText';
import { GatsbyImage } from 'gatsby-plugin-image'

const Footer = () => {

	const {
		contentfulFooter: {
			copyrights,
			footerMessage,
			socialLinks, 
			detailsLinks,
			footerLogos
		}
	  } = useStaticQuery(
	    graphql`
	      query {
			contentfulFooter {
				copyrights
				footerMessage {
					raw
				}
				socialLinks {
					title
					url
				}
				detailsLinks {
					title
					url
					linkType
				}
				footerLogos {
					...Image
				}
			}
	      }
	    `
	  )

	return (
		<footer className={classes.footer}>
			<div className={classes.cont}>
				<div className={classes.row}>
					<div className={classes.mainCol}>
						{footerMessage && <RichText useHeadings="Heading 2" className={classes.newsletterMessage} content={footerMessage}/>}
						<SubscribeForm />
					</div>
					<div className={classes.colSpace}></div>
					<div className={classes.col}>
						<h3 className={classes.linksTitle}>Socials</h3>
						<ul className={classes.fastlinks}>
						{socialLinks.map((item, index) => (
							<li key={index}><a href={item.url} target="_blank" className={classes.link}>{item.title}</a></li>
						))}
						</ul>
					</div>
					<div className={classes.col}>
						<h3 className={classes.linksTitle}>Details</h3>
						<ul className={classes.fastlinks}>
						{detailsLinks.map((item, index) => (
							<li key={index}>
								{item.linkType ==='internal' ?
									<Link to={item.url} className={classes.link}>{item.title}</Link>
									:
									<a href={item.url} target='_blank' className={classes.link}>{item.title}</a>
								}
							</li>
						))}
						</ul>
					</div>
				</div>
				<div className={classes.bottomRow}>
					<div className={classes.logoCol}>
						<Logo className={`${classes.svg} animated-logo`}/>
						<a href="https://bravebison.com/" target='_blank' className={classes.footerSubTitle}>Part of <strong className={classes.bb}>Br<span className={classes.spiCh}>a</span>veBison</strong></a>
					</div>
					<div className={classes.partnersCol}>
						{footerLogos.length > 0 && footerLogos.map((item, index) => (
							<div className={classes.logo}>
								<GatsbyImage
									image={item.gatsbyImageData}
									alt={item.description || ''}
								/>
							</div>
						))}
					</div>
				</div>
				<div className={classes.copyrights}>{copyrights}</div>
			</div>
		</footer>
	)
}

export default Footer

Footer.propTypes = {
};